'use client';

import Image from '@/components/Image';
import { ResponsiveContext } from '@/components/Responsive/ResponsiveProvider';
import WapOnly from '@/components/Responsive/WapOnly';
import WebOnly from '@/components/Responsive/WebOnly';
import { useReporting } from '@/hooks/useReporting';
import { useStore } from '@/providers/app-store-provider';
import { ProviderType } from '@/reporting';
import { font } from '@/theme/zeelool.theme';
import { EPlatform } from '@/utils/enums/platform-enum';
import { Box, Button, Typography } from '@mui/material';
import { useTranslations } from 'next-intl';
import { useContext, useState } from 'react';
interface PrivilegeItem {
  iconSrc: string;
  title: string;
}

export default function UnauthenticatedBanner({
  btnText = 'Sign In',
  refreshFreeData,
}: {
  btnText?: string;
  refreshFreeData: () => void;
}) {
  const t = useTranslations('account.redeemableItems.unauthenticatedBanner');
  const { deviceType } = useContext(ResponsiveContext);
  const privileges: PrivilegeItem[] = [
    {
      iconSrc: '/account/redeemable-items/price-privilege.png', // 礼物/价格图标
      title: t('privileges.price'),
    },
    {
      iconSrc: '/account/redeemable-items/welfare-privilege.png', // 美元符号图标
      title: t('privileges.welfare'),
    },
    {
      iconSrc: '/account/redeemable-items/points-privilege.png', // 钱币/点数图标
      title: t('privileges.points'),
    },
    {
      iconSrc: '/account/redeemable-items/service-privilege.png', // 聊天/服务图标
      title: t('privileges.service'),
    },
  ];
  const token = useStore((state) => state.token);
  const refreshAccountInfo = useStore((state) => state.refreshAccountInfo);
  const [joinMemberLoading, setJoinMemberLoading] = useState(false);
  const { trackEvent } = useReporting();
  const setShowLoginRegisterDialog = useStore((state) => state.setShowLoginRegisterDialog);
  const setJoinFreeDialogInfo = useStore((state) => state.setJoinFreeDialogInfo);
  const signIn = async () => {
    trackEvent(
      {
        eventName: 'PointsMallPageBtn_Click',
        properties: {
          btn_name: btnText,
        },
      },
      [ProviderType.SENSORS],
    );
    if (token) {
      handleJoinMember();
    } else {
      setShowLoginRegisterDialog(true);
    }
  };
  const handleJoinMember = async () => {
    // try {
    //   setJoinMemberLoading(true);
    //   await postJoinMember({});
    //   await refreshAccountInfo();
    // } catch (error) {
    //   console.error('Failed to join member:', error);
    // } finally {
    //   setJoinMemberLoading(false);
    // }
    setJoinMemberLoading(true);
    setJoinFreeDialogInfo({
      show: true,
    });
    setJoinMemberLoading(false);
    setTimeout(() => {
      refreshAccountInfo();
      refreshFreeData();
    }, 3000);
  };

  return (
    <Box
      className={`bg-auxiliary-light-purple mb-[30px] flex items-center ${
        deviceType === EPlatform.WEB
          ? 'w-full rounded-[12px] pt-[34px] pr-[50px] pb-[34px] pl-24 justify-between'
          : 'rounded-[10px] pt-16 pb-12 flex-col'
      }`}
    >
      <Box>
        <Typography
          component="h2"
          sx={{
            fontSize: deviceType === EPlatform.WEB ? '24px' : '16px',
            lineHeight: deviceType === EPlatform.WEB ? '36px' : '24px',
            fontFamily: font.bb,
            mb: deviceType === EPlatform.WEB ? 3 : 2,
            textAlign: deviceType === EPlatform.WEB ? 'left' : 'center',
          }}
        >
          <WebOnly>
            {t('title')} {t('subtitle')}
          </WebOnly>
          <WapOnly>
            {t('title')}
            <br />
            {t('subtitle')}
          </WapOnly>
        </Typography>
        <Box
          className={`flex items-center ${deviceType === EPlatform.WEB ? 'gap-[12px]' : 'w-[320px] justify-between mb-16'}`}
        >
          {privileges.map((item) => (
            <Box
              key={item.title}
              className={`flex items-center ${deviceType === EPlatform.WEB ? 'flex-row' : 'flex-col w-[60px]'}`}
            >
              <Box
                className={`w-[28px] h-[28px] flex items-center justify-center ${
                  deviceType === EPlatform.WEB ? 'mr-[8px]' : 'mb-2'
                }`}
              >
                <Image src={item.iconSrc} alt={item.title} width={28} height={28} />
              </Box>
              <Typography
                sx={{
                  fontSize: deviceType === EPlatform.WEB ? '14px' : '12px',
                  lineHeight: deviceType === EPlatform.WEB ? '20px' : '16px',
                  textAlign: deviceType === EPlatform.WEB ? 'left' : 'center',
                }}
              >
                {item.title}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
      <Button
        variant="contained"
        color="primary"
        onClick={signIn}
        loading={joinMemberLoading}
        sx={{
          width: deviceType === EPlatform.WEB ? '224px' : '264px',
          height: deviceType === EPlatform.WEB ? '40px' : '36px',
          borderRadius: deviceType === EPlatform.WEB ? '20px' : '22px',
          fontFamily: font.bb,
          fontSize: deviceType === EPlatform.WEB ? '16px' : '14px',
        }}
      >
        {btnText}
      </Button>
    </Box>
  );
}
